import { useEffect } from 'react'

import { useQuery } from 'react-query'

import { getVirtualCardPaymentDetailsUseCase } from '@webapp/modules/spending-cards/business-logic/use-cases/GetVirtualCardPaymentDetails'
import { SpendingCardKeys } from '@webapp/modules/spending-cards/entities/enums/SpendingCardKeysEnum'

type UseQueryVirtualCardPaymentDetailsReturn = {
  iframeUrl: string | undefined
  isFetching: boolean
  refetch: () => void
  clearIframeUrl: () => void
}

export const useQueryVirtualCardPaymentDetails = ({
  externalId,
  scaToken,
  onVerificationRequired = () => undefined,
  customCss = {},
  enabled = true,
  onError = () => undefined,
}: {
  externalId: string
  scaToken?: string
  onVerificationRequired?: (scaSessionCode: string) => void
  customCss?: Record<string, Record<string, string>>
  enabled?: boolean
  onError?: (error: Error) => void
}): UseQueryVirtualCardPaymentDetailsReturn => {
  const { data, isFetching, remove, refetch } = useQuery({
    queryKey: [
      ...SpendingCardKeys.GET_CARD_PAYMENT_DETAILS,
      externalId,
      scaToken,
    ],
    queryFn: () =>
      getVirtualCardPaymentDetailsUseCase({ externalId, customCss, scaToken }),
    enabled,
    onError,
  })

  const scaSessionCode =
    !!data && 'scaSessionCode' in data?.data
      ? data.data.scaSessionCode
      : undefined
  useEffect(() => {
    if (scaSessionCode) {
      onVerificationRequired(scaSessionCode)
    }
  }, [scaSessionCode])

  useEffect(() => {
    return () => remove()
  }, [remove])

  return {
    iframeUrl: data?.data?.url,
    refetch,
    isFetching,
    clearIframeUrl: () => {
      remove()
    },
  }
}
